import React from 'react';
import StyledText from 'components/Helpers/StyledText/StyledText';

const ListItem = ({ value }) => {
  const style = require('./Lista.scss');
  if (typeof value === 'string') {
    return (
      <li className={style.li}>
        <StyledText>{value}</StyledText>
      </li>
    );
  } else {
    return (
      <li className={style.objli}>
        {value && value.bild && <span>bild:{value.bild}</span>}
        {value && value.text && <StyledText>{value.text}</StyledText>}
      </li>
    );
  }
};

export default ListItem;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/Lista/_ListItem.js
 **/